import React from 'react';
import { observer } from 'mobx-react';
import dashboardSettingsStore from '../../../../../stores/dashboard-settings-store';
import AppHeaderNotificationLink, { NOTIFICATION_LINK_TYPE } from './app-header-notification-link';
import useDashboardTranslation from '../../../../../dashboard-translation/hooks/dashboard-translation-hook';
import TermsReviewNoticeModal from '../../../../../pages/home/components/terms-review-notice-modal/terms-review-notice-modal';
import { PROFILE_CAPABILITIES } from '../../../../../models/ProfileCapabilities';

const HeaderNotifications: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-top-bar';
    const termsAcceptance = dashboardSettingsStore.resolveCapability(PROFILE_CAPABILITIES.TERMS_ACCEPTANCE);
    const showTermsReviewNotice = !!termsAcceptance?.isSupported
        && dashboardSettingsStore.termsReviewNoticeVisible
        && !dashboardSettingsStore.termsAcceptanceRequired
        && !!dashboardSettingsStore.termsContent;

    if (
        !dashboardSettingsStore.scopeChangeUrl
        && !dashboardSettingsStore.acceptNewPlanUrl
        && !showTermsReviewNotice
    ) {
        return null;
    }

    return (
        <div className="header-notifications">
            {!!dashboardSettingsStore.scopeChangeUrl && (
                <AppHeaderNotificationLink
                    type={NOTIFICATION_LINK_TYPE.WARNING}
                    href={dashboardSettingsStore.scopeChangeUrl}
                    text={getTranslation('APPROVE_PERMISSIONS', scope)}
                />
            )}
            {!!dashboardSettingsStore.acceptNewPlanUrl && (
                <AppHeaderNotificationLink
                    type={NOTIFICATION_LINK_TYPE.INFO}
                    href={dashboardSettingsStore.acceptNewPlanUrl!}
                    text={getTranslation('ACCEPT_NEW_PLAN_BUTTON', scope)}
                />
            )}
            {showTermsReviewNotice && <TermsReviewNoticeModal />}
        </div>
    );
});

export default HeaderNotifications;
